// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.eyefinity.RemakeEyefinityOrderRequest */
/* istanbul ignore next */
@GandalfModel
export class RemakeEyefinityOrderRequest extends GandalfModelBase {

	@GandalfLabel('VSP Order Detail')
	@GandalfValidator({ notNull: { message: 'VSP Order Detail is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	eyefinityOrderDetailId!: number;

	@GandalfLabel('Remake Reason')
	@GandalfValidator({ notNull: { message: 'Remake Reason is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	nonBillableReasonId!: number;

}
